import { render, staticRenderFns } from "./ReportForkliftTruck.vue?vue&type=template&id=68c8175c&"
import script from "./ReportForkliftTruck.vue?vue&type=script&lang=js&"
export * from "./ReportForkliftTruck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QField,QIcon,QTable,QTr,QTh,QTd,QBtn,QTooltip,QCheckbox} from 'quasar'
component.options.components = Object.assign({QItem,QField,QIcon,QTable,QTr,QTh,QTd,QBtn,QTooltip,QCheckbox}, component.options.components || {})
